<template>
  <div>
    <b-container>
      <b-row class="mt-3">
        <b-col cols="12" sm="2" order="2" order-md="1">
          <b-button block to="/" variant="primary" class="mt-3 mt-md-0"
            >« Back</b-button
          >
        </b-col>
        <b-col cols="12" sm="8" class="text-center" order="1" order-md="2">
          <logo></logo>
        </b-col>
        <b-col class="d-none d-md-block" order-md="3">
          <b-button
            target="_blank"
            href="https://github.com/Crodev/codeimg_feedback/issues"
            variant="success"
          >
            Request Feature
          </b-button>
        </b-col>
      </b-row>
      <hr />
    </b-container>
    <b-container class="kanban-container">
      <b-row>
        <b-col cols="12">
          <h2>ToDo</h2>

          <b-card v-for="item in todo" :key="item.title" :title="item.title">
            <b-card-text v-html="item.content"> </b-card-text>
            <b-badge variant="secondary">Backlog</b-badge>
          </b-card>
        </b-col>
        <b-col cols="12">
          <h2>In Progress</h2>

          <b-card
            v-for="item in inProgress"
            :key="item.title"
            :title="item.title"
          >
            <b-card-text v-html="item.content"> </b-card-text>
            <b-badge variant="primary">In progress</b-badge>
          </b-card>
        </b-col>
        <b-col cols="12">
          <h2>Released</h2>

          <b-card
            v-for="item in published"
            :key="item.title"
            :title="item.title"
          >
            <b-card-text v-html="item.content"> </b-card-text>
            <b-badge variant="success">Published</b-badge>&nbsp;<b-badge
              variant="soft-success"
              >{{ item.release }}</b-badge
            >
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import logo from "@/components/logo.vue";
// kentico cloud
import { DeliveryClient } from "kentico-cloud-delivery";
export default {
  name: "Board",
  data() {
    return {
      todo: [],
      inProgress: [],
      published: []
    };
  },
  components: {
    logo
  },
  methods: {},
  computed: {},
  created() {
    let Client = new DeliveryClient({
      projectId: "de70d50b-aad8-00ae-0316-810f291f741b"
    });

    Client.items()
      .type("board")
      .getPromise()
      .then(response => {
        var todo = this._.filter(response.items, i => {
          return i.board_snippet__state.value[0].codename === "backlog";
        });

        var inProgress = this._.filter(response.items, i => {
          return i.board_snippet__state.value[0].codename === "in_progress";
        });

        var published = this._.filter(response.items, i => {
          return i.board_snippet__state.value[0].codename === "published";
        });

        this.todo = this._.map(todo, i => {
          return {
            title: i.board_snippet__title.value,
            content: i.board_snippet__content.value,
            release: !this._.isEmpty(i.board_snippet__releases.value)
              ? i.board_snippet__releases.value[0].name
              : undefined
          };
        });

        this.inProgress = this._.map(inProgress, i => {
          return {
            title: i.board_snippet__title.value,
            content: i.board_snippet__content.value,
            release: !this._.isEmpty(i.board_snippet__releases.value)
              ? i.board_snippet__releases.value[0].name
              : undefined
          };
        });

        this.published = this._.map(published, i => {
          return {
            title: i.board_snippet__title.value,
            content: i.board_snippet__content.value,
            release: !this._.isEmpty(i.board_snippet__releases.value)
              ? i.board_snippet__releases.value[0].name
              : undefined
          };
        });
      });
  }
};
</script>

<style scoped></style>
